export const VALIDATION_MODULE = "validationModule";
export const VALIDATION_MODULE_ALT_NAME = `__${VALIDATION_MODULE}_alt`;
export const TRANSFORM_MODULE = "transformationModule";
export const TRANSFORM_MODULE_ALT_NAME = `__${TRANSFORM_MODULE}_alt`;
export const LAM_MODEL_FUNCTIONS = "lamModelFunctions";
export const LAM_MODEL_FUNCTIONS_ALT_NAME = `__${LAM_MODEL_FUNCTIONS}_alt`;
export const EXPERIMENT_MODULE = "experimentalFunctions";
export const EXPERIMENT_MODULE_ALT_NAME = `__${EXPERIMENT_MODULE}_alt`;
export const LAM_TRANSFORMATIONS_EVENT_FLAG =
  "lllAnalytisTransformationInitialized";

export const ONETRUST_CONSENT_COOKIE_NAME = "OptanonConsent";
// This is set by launch
// TODO: Before launch goes away, confirm this is the correct name for ESW OneTrust cookie
export const ESW_ONETRUST_CONSENT_COOKIE_NAME = "intlOTConsent";
